// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableEdit {
  width: 95vw;
  font-size: 0.9em;
  font-family: sans-serif;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
  margin: 2vh auto;
  table-layout: fixed;
}
.tableEdit thead {
  height: 4vh;
}
.tableEdit thead tr {
  background-color: #2c53a0;
  color: #ffffff;
  text-align: left;
}
.tableEdit thead tr th {
  text-align: center;
}
.tableEdit tbody tr {
  border-bottom: 1px solid #dddddd;
}
.tableEdit tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.tableEdit tbody tr:first-of-type {
  border-top: 2px solid #2c53a0;
}
.tableEdit tbody tr:last-of-type {
  border-bottom: 2px solid #2c53a0;
}
.tableEdit tbody tr td {
  padding: 12px 15px;
  word-wrap: break-word;
}
.tableEdit tbody tr td .input_number {
  border-radius: 3px;
  border: 2px solid #2c53a0;
  width: 50px;
  height: 3vh;
  text-align: center;
}
.tableEdit tbody tr td input::-webkit-outer-spin-button,
.tableEdit tbody tr td input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
@media (max-width: 1000px) {
  .tableEdit {
    display: block;
  }
  .tableEdit input {
    width: 100%;
  }
  .tableEdit thead {
    height: 0;
    display: block;
  }
  .tableEdit thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  .tableEdit thead tr th {
    display: block;
  }
  .tableEdit td:nth-of-type(1):before {
    content: "Product";
  }
  .tableEdit td:nth-of-type(2):before {
    content: "Warehouse";
  }
  .tableEdit td:nth-of-type(3):before {
    content: "Order Code";
  }
  .tableEdit td:nth-of-type(4):before {
    content: "Case Barcode";
  }
  .tableEdit td:nth-of-type(5):before {
    content: "Case Size";
  }
  .tableEdit td:nth-of-type(6):before {
    content: "Actions";
  }
  .tableEdit tbody {
    display: block;
  }
  .tableEdit tbody tr {
    display: block;
    margin-bottom: 0.5vh;
    border: 1px solid #ccc;
  }
  .tableEdit tbody tr td {
    display: block;
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }
  .tableEdit tbody tr td:before {
    position: absolute;
    top: 10px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    font-weight: 700;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/quickEdit/edit.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAEI;EACI,WAAA;AAAR;AACQ;EACI,yBCXA;EDYA,cAAA;EACA,gBAAA;AACZ;AAAY;EACI,kBAAA;AAEhB;AAIQ;EACI,gCAAA;AAFZ;AAIY;EACI,yBAAA;AAFhB;AAIY;EACI,6BAAA;AAFhB;AAIY;EACI,gCAAA;AAFhB;AAKY;EACI,kBAAA;EACA,qBAAA;AAHhB;AAIgB;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AAFpB;AAIgB;;EAEI,wBAAA;EACA,SAAA;AAFpB;AAOI;EAnDJ;IAoDQ,cAAA;EAJN;EAMM;IACI,WAAA;EAJV;EAOM;IACI,SAAA;IACA,cAAA;EALV;EAMU;IACI,kBAAA;IACA,YAAA;IACA,aAAA;EAJd;EAKc;IACI,cAAA;EAHlB;EAOU;IACI,kBAAA;EALd;EAOU;IACI,oBAAA;EALd;EAOU;IACI,qBAAA;EALd;EAOU;IACI,uBAAA;EALd;EAOU;IACI,oBAAA;EALd;EAOU;IACI,kBAAA;EALd;EAQM;IACI,cAAA;EANV;EAOU;IACI,cAAA;IACA,oBAAA;IACA,sBAAA;EALd;EAMc;IACI,cAAA;IACA,YAAA;IACA,6BAAA;IACA,kBAAA;IACA,iBAAA;EAJlB;EAOc;IACI,kBAAA;IACA,SAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;EALlB;AACF","sourcesContent":["@import \"../../variables.scss\";\n\n.tableEdit {\n    width: 95vw;\n    font-size: 0.9em;\n    font-family: sans-serif;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);\n    margin: 2vh auto;\n    table-layout: fixed;\n    thead {\n        height: 4vh;\n        tr {\n            background-color: $nitroDark;\n            color: #ffffff;\n            text-align: left;\n            th {\n                text-align: center;\n            }\n        }\n    }\n\n    tbody {\n        tr {\n            border-bottom: 1px solid #dddddd;\n\n            &:nth-of-type(even) {\n                background-color: #f3f3f3;\n            }\n            &:first-of-type {\n                border-top: 2px solid $nitroDark;\n            }\n            &:last-of-type {\n                border-bottom: 2px solid $nitroDark;\n            }\n\n            td {\n                padding: 12px 15px;\n                word-wrap: break-word;\n                .input_number {\n                    border-radius: 3px;\n                    border: 2px solid $nitroDark;\n                    width: 50px;\n                    height: 3vh;\n                    text-align: center;\n                }\n                input::-webkit-outer-spin-button,\n                input::-webkit-inner-spin-button {\n                    -webkit-appearance: none;\n                    margin: 0;\n                }\n            }\n        }\n    }\n    @media (max-width: $tablet) {\n        display: block;\n\n        input{\n            width:100%;\n        }\n\n        thead {\n            height: 0;\n            display: block;\n            tr {\n                position: absolute;\n                top: -9999px;\n                left: -9999px;\n                th {\n                    display: block;\n                }\n            }\n        }\n            td:nth-of-type(1):before {\n                content: \"Product\";\n            }\n            td:nth-of-type(2):before {\n                content: \"Warehouse\";\n            }\n            td:nth-of-type(3):before {\n                content: \"Order Code\";\n            }\n            td:nth-of-type(4):before {\n                content: \"Case Barcode\";\n            }\n            td:nth-of-type(5):before {\n                content: \"Case Size\";\n            }\n            td:nth-of-type(6):before {\n                content: \"Actions\";\n            }\n\n        tbody {\n            display: block;\n            tr {\n                display: block;\n                margin-bottom: 0.5vh;\n                border: 1px solid #ccc;\n                td {\n                    display: block;\n                    border: none;\n                    border-bottom: 1px solid #eee;\n                    position: relative;\n                    padding-left: 50%;\n                }\n\n                td:before {\n                    position: absolute;\n                    top: 10px;\n                    left: 6px;\n                    width: 45%;\n                    padding-right: 10px;\n                    white-space: nowrap;\n                    font-weight: 700;\n                    text-align: left;\n                }\n            }\n        }\n    }\n}","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 89vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex(\n    $justify: \"center\",\n    $align: \"center\",\n    $direction: \"row\",\n    $gap: \"10px\"\n) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n\n    // For Internet Explorer\n    & {\n        scrollbar-face-color: $foreground-color;\n        scrollbar-track-color: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
